const isHTTPS = window.location.protocol === "https:";
const REACT_APP_HTTP_API_URL = process.env.REACT_APP_HTTP_API_URL || "http://localhost:8000/api/";
const REACT_APP_HTTPS_API_URL = process.env.REACT_APP_HTTPS_API_URL || "http://localhost:8000/api/";

const REACT_APP_SOCKET_URL = process.env.REACT_APP_SOCKET_URL || "http://localhost:8000/api/";
const REACT_APP_SOCKETS_URL = process.env.REACT_APP_SOCKETS_URL || "http://localhost:8000/api/";
// export const SERVER = "https://admin.beon.am/api/" //serverLink
// export const SERVER = "https://admin.beon.am/api/"
// export const SERVER = "https://testadmin.beon.am/api/"
// export const SERVER = "http://localhost:8000/api/"

export const REACT_APP_API_URL = isHTTPS
    ? REACT_APP_HTTPS_API_URL
    : REACT_APP_HTTP_API_URL;

export const REACT_SOCKET_URL = isHTTPS
    ? REACT_APP_SOCKETS_URL
    : REACT_APP_SOCKET_URL;

